export default "__VITE_PUBLIC_ASSET__5874ff25__"